import React, { useEffect, useState } from "react";
import { Send, ArrowLeft, Bot } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ThemeToggle } from "./components/ThemeToggle";
export function Scoping() {
  const navigate = useNavigate();
  useEffect(() => {
    const isAuthenticated = false; // This would come from your auth state
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [navigate]);
  const [messages, setMessages] = useState([{
    type: "bot",
    content: "Welcome to the project scoping session! Let's define your MVP in detail. First, could you describe your project's main purpose and core features?",
    category: "purpose"
  }]);
  const [input, setInput] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const scopingSteps = ["What is your project's main purpose?", "Who are your target users?", "What are the must-have features for your MVP?", "What is your timeline expectation?", "Do you have any specific technical requirements?", "What is your budget range?"];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim()) return;
    setMessages(prev => [...prev, {
      type: "user",
      content: input
    }]);
    setTimeout(() => {
      if (currentStep < scopingSteps.length - 1) {
        setMessages(prev => [...prev, {
          type: "bot",
          content: scopingSteps[currentStep + 1]
        }]);
        setCurrentStep(currentStep + 1);
      } else {
        setMessages(prev => [...prev, {
          type: "bot",
          content: "Thank you for providing all this information! I'll analyze your requirements and provide a detailed scope recommendation."
        }]);
      }
    }, 1000);
    setInput("");
  };
  return <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800" data-id="element-545">
      <header className="fixed top-0 w-full bg-white dark:bg-gray-900 border-b dark:border-gray-700 z-50" data-id="element-546">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-547">
          <div className="flex items-center justify-between h-16" data-id="element-548">
            <button onClick={() => navigate("/")} className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center" data-id="element-549">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-550" />
              Back to Home
            </button>
            <div className="flex items-center space-x-4" data-id="element-551">
              <ThemeToggle data-id="element-552" />
              <div onClick={() => navigate("/")} className="text-xl font-bold text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-700 dark:hover:text-blue-300 transition-colors" data-id="element-553">
                <span data-id="element-554">MVP</span>
                <span data-id="element-555">Hub.co</span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8" data-id="element-556">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden" data-id="element-557">
          <div className="border-b dark:border-gray-700 p-4 bg-gray-50 dark:bg-gray-900" data-id="element-558">
            <div className="flex items-center space-x-3" data-id="element-559">
              <div className="bg-blue-600 p-2 rounded-lg" data-id="element-560">
                <Bot className="w-6 h-6 text-white" data-id="element-561" />
              </div>
              <div data-id="element-562">
                <h1 className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-563">
                  Project Scoping Assistant
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-564">
                  Let's define your MVP requirements
                </p>
              </div>
            </div>
          </div>
          <div className="h-[600px] overflow-y-auto p-4 space-y-4" data-id="element-565">
            {messages.map((message, index) => <div key={index} className={`flex ${message.type === "user" ? "justify-end" : "justify-start"}`} data-id="element-566">
                <div className={`rounded-lg px-4 py-2 max-w-[80%] ${message.type === "user" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-900"}`} data-id="element-567">
                  {message.content}
                </div>
              </div>)}
          </div>
          <form onSubmit={handleSubmit} className="border-t p-4 bg-white" data-id="element-568">
            <div className="flex space-x-4" data-id="element-569">
              <input type="text" value={input} onChange={e => setInput(e.target.value)} placeholder="Type your response..." className="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-570" />
              <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center" data-id="element-571">
                Send
                <Send className="w-4 h-4 ml-2" data-id="element-572" />
              </button>
            </div>
            <div className="mt-2 text-sm text-gray-500" data-id="element-573">
              Step {currentStep + 1} of {scopingSteps.length}
            </div>
          </form>
        </div>
      </main>
    </div>;
}